import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloFluxBuilder, cleanAloFluxBuilder } from '@/models/alo/AloFluxBuilder'
import { ApiResultCode } from '@/enum/ApiResultCode'

export default {
  getAllFluxBuilder(): AxiosPromise<AlrContainer<Array<AloFluxBuilder>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FluxBuilder`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFluxBuilder>>
      }]
    })
  },
  getFluxBuilder(id:number):AxiosPromise<AlrContainer<AloFluxBuilder>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FluxBuilder/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloFluxBuilder>
      }]
    })
  },
  saveFluxBuilder(fluxBuilder:AloFluxBuilder):AxiosPromise<AlrContainer<AloFluxBuilder>> {
    cleanAloFluxBuilder(fluxBuilder)
    if(fluxBuilder.id) {
      const oldId = fluxBuilder.id
      fluxBuilder.id = fluxBuilder.newId
      delete fluxBuilder.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/FluxBuilder/${oldId}`, 
        method: 'PUT',
        data: fluxBuilder,
        transformResponse: [function (data:string) {   
          const  resp = JSON.parse(data) as AlrContainer<AloFluxBuilder>     
          if(resp.resultCode == ApiResultCode.Ok){
            //@ts-ignore
            resp.data.newId = oldId
          }  
          return resp
        }]
      })    
    }
    else{
      fluxBuilder.id = fluxBuilder.newId
      delete fluxBuilder.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/FluxBuilder`, 
        method: 'POST',
        data: fluxBuilder,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFluxBuilder>
        }]
      })    
    }
  },
  deleteFluxBuilder(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FluxBuilder/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  }
}